import type { SubjectRef } from '~portal/data';

/**
 * @desc The page a cross-link opens: an operator group's company page or a region's market page.
 * Returned as a literal route so the router `Link` stays type-checked against the route tree.
 */
export const subjectRoute = (subject: Pick<SubjectRef, 'kind'>) =>
  subject.kind === 'operator' ? ('/operators/$slug' as const) : ('/regions/$slug' as const);
